// Architectural top-down floor plan — matches the reference image style:
// thin black lines only, real architectural furniture symbols (top view).
// Click any room to fill it hot-pink and reveal cleaning products for that space.

window.BLC_FLOORPLAN_SVG = `
<svg viewBox="0 0 800 900" xmlns="http://www.w3.org/2000/svg" class="fp-svg" preserveAspectRatio="xMidYMid meet">

  <!-- ============ HOUSE OUTLINE ============ -->
  <rect x="60" y="60" width="680" height="780" fill="#ffffff" stroke="#17181a" stroke-width="6"/>

  <!-- ============ INTERIOR WALLS ============ -->
  <g stroke="#17181a" stroke-width="4" fill="none">
    <!-- Top row: bedroom | bath | kitchen -->
    <line x1="240" y1="60" x2="240" y2="290"/>
    <line x1="380" y1="60" x2="380" y2="290"/>
    <line x1="60" y1="290" x2="380" y2="290"/>
    <!-- Kitchen separated from living area by a horizontal wall break -->
    <line x1="380" y1="290" x2="740" y2="290"/>
    <!-- Middle row: master bedroom | living room -->
    <line x1="380" y1="290" x2="380" y2="620"/>
    <line x1="60" y1="620" x2="380" y2="620"/>
    <!-- Bottom row: 3 rooms -->
    <line x1="240" y1="620" x2="240" y2="840"/>
    <line x1="440" y1="620" x2="440" y2="840"/>
  </g>

  <!-- ============ DOOR OPENINGS (gaps in walls) ============ -->
  <g stroke="#ffffff" stroke-width="6">
    <line x1="150" y1="290" x2="200" y2="290"/> <!-- bedroom door -->
    <line x1="290" y1="290" x2="340" y2="290"/> <!-- bath door -->
    <line x1="60" y1="440" x2="60" y2="490"/>   <!-- master bedroom exterior door -->
    <line x1="380" y1="410" x2="380" y2="460"/> <!-- living/kitchen threshold -->
    <line x1="380" y1="700" x2="380" y2="750"/> <!-- office door -->
    <line x1="120" y1="620" x2="170" y2="620"/> <!-- master bedroom to hall -->
    <line x1="500" y1="620" x2="550" y2="620"/> <!-- living to laundry -->
  </g>
  <g stroke="#17181a" stroke-width="1.2" fill="none">
    <!-- Door swing arcs -->
    <path d="M 200 290 A 50 50 0 0 1 150 340" stroke-dasharray="3 3"/>
    <line x1="150" y1="290" x2="150" y2="340" stroke-width="1.5"/>
    <path d="M 340 290 A 50 50 0 0 1 290 340" stroke-dasharray="3 3"/>
    <line x1="290" y1="290" x2="290" y2="340" stroke-width="1.5"/>
    <path d="M 30 490 A 50 50 0 0 0 60 440" stroke-dasharray="3 3"/>
    <line x1="30" y1="490" x2="60" y2="490" stroke-width="1.5"/>
  </g>

  <!-- ============ WINDOWS (double lines on exterior walls) ============ -->
  <g stroke="#17181a" stroke-width="1.5" fill="#ffffff">
    <!-- Top wall -->
    <rect x="130" y="57" width="80" height="6"/>
    <line x1="130" y1="60" x2="210" y2="60" stroke-width="0.5"/>
    <rect x="440" y="57" width="80" height="6"/>
    <line x1="440" y1="60" x2="520" y2="60" stroke-width="0.5"/>
    <rect x="600" y="57" width="80" height="6"/>
    <line x1="600" y1="60" x2="680" y2="60" stroke-width="0.5"/>
    <!-- Right wall -->
    <rect x="737" y="180" width="6" height="80"/>
    <line x1="740" y1="180" x2="740" y2="260" stroke-width="0.5"/>
    <rect x="737" y="380" width="6" height="80"/>
    <line x1="740" y1="380" x2="740" y2="460" stroke-width="0.5"/>
    <rect x="737" y="580" width="6" height="80"/>
    <line x1="740" y1="580" x2="740" y2="660" stroke-width="0.5"/>
    <!-- Left wall -->
    <rect x="57" y="180" width="6" height="80"/>
    <line x1="60" y1="180" x2="60" y2="260" stroke-width="0.5"/>
    <rect x="57" y="720" width="6" height="80"/>
    <line x1="60" y1="720" x2="60" y2="800" stroke-width="0.5"/>
    <!-- Bottom wall -->
    <rect x="130" y="837" width="80" height="6"/>
    <line x1="130" y1="840" x2="210" y2="840" stroke-width="0.5"/>
    <rect x="500" y="837" width="80" height="6"/>
    <line x1="500" y1="840" x2="580" y2="840" stroke-width="0.5"/>
    <rect x="620" y="837" width="80" height="6"/>
    <line x1="620" y1="840" x2="700" y2="840" stroke-width="0.5"/>
  </g>

  <!-- ============ ROOMS with top-down furniture ============ -->
  <g class="fp-rooms">

    <!-- BEDROOM 1 (top-left) -->
    <g class="fp-room" data-room="bedroom">
      <rect class="fp-hit" x="60" y="60" width="180" height="230" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="60" y="60" width="180" height="230" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- desk with chair (top-left area) -->
        <rect x="80" y="110" width="70" height="35" rx="2"/>
        <circle cx="115" cy="170" r="14"/>
        <!-- bed (right side of bedroom, top-view) -->
        <rect x="170" y="100" width="55" height="140" rx="4"/>
        <!-- pillow -->
        <rect x="177" y="108" width="41" height="22" rx="3"/>
        <!-- nightstand -->
        <circle cx="185" cy="150" r="8" fill="#fff"/>
      </g>
      <text x="150" y="270" text-anchor="middle" class="fp-label">Bedroom</text>
    </g>

    <!-- BATHROOM (top-middle) -->
    <g class="fp-room" data-room="bathroom">
      <rect class="fp-hit" x="240" y="60" width="140" height="230" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="240" y="60" width="140" height="230" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- bathtub / shower (curved corner) -->
        <path d="M 260 90 L 260 170 Q 260 190 280 190 L 350 190 L 350 90 Z" fill="#ffffff"/>
        <path d="M 275 105 L 275 165 Q 275 175 285 175 L 340 175" fill="none"/>
        <circle cx="345" cy="100" r="3" fill="#17181a"/>
        <!-- toilet -->
        <rect x="330" y="200" width="30" height="18" rx="3"/>
        <ellipse cx="345" cy="235" rx="15" ry="18"/>
        <!-- sink -->
        <rect x="255" y="220" width="55" height="45" rx="3"/>
        <circle cx="282" cy="242" r="14"/>
        <circle cx="282" cy="242" r="2" fill="#17181a"/>
      </g>
      <text x="310" y="275" text-anchor="middle" class="fp-label" style="font-size:16px;">Bathroom</text>
    </g>

    <!-- KITCHEN (top-right) -->
    <g class="fp-room" data-room="kitchen">
      <rect class="fp-hit" x="380" y="60" width="360" height="230" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="380" y="60" width="360" height="230" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- Counter run along top wall -->
        <rect x="395" y="80" width="335" height="55" rx="2"/>
        <!-- sink -->
        <rect x="410" y="95" width="60" height="35" rx="3"/>
        <line x1="440" y1="95" x2="440" y2="130"/>
        <!-- cooktop with 4 burners -->
        <rect x="500" y="90" width="80" height="42" rx="3"/>
        <circle cx="518" cy="103" r="6"/>
        <circle cx="560" cy="103" r="6"/>
        <circle cx="518" cy="122" r="6"/>
        <circle cx="560" cy="122" r="6"/>
        <!-- oven controls -->
        <line x1="588" y1="98" x2="588" y2="125"/>
        <line x1="600" y1="98" x2="600" y2="125"/>
        <!-- fridge -->
        <rect x="620" y="88" width="55" height="45" rx="3"/>
        <line x1="620" y1="105" x2="675" y2="105"/>
      </g>
      <text x="560" y="240" text-anchor="middle" class="fp-label">Kitchen</text>
    </g>

    <!-- DINING ROOM (right side, upper-middle) -->
    <g class="fp-room" data-room="dining">
      <rect class="fp-hit" x="380" y="290" width="360" height="180" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="380" y="290" width="360" height="180" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- Rectangular dining table -->
        <rect x="510" y="320" width="90" height="140" rx="3"/>
        <line x1="555" y1="320" x2="555" y2="460"/>
        <!-- 6 chairs — 2 top, 2 bottom, 1 each side -->
        <rect x="522" y="298" width="26" height="16" rx="3"/>
        <rect x="562" y="298" width="26" height="16" rx="3"/>
        <rect x="522" y="466" width="26" height="16" rx="3"/>
        <rect x="562" y="466" width="26" height="16" rx="3"/>
        <rect x="488" y="360" width="16" height="26" rx="3"/>
        <rect x="606" y="360" width="16" height="26" rx="3"/>
      </g>
      <text x="450" y="400" text-anchor="middle" class="fp-label">Dining</text>
    </g>

    <!-- LIVING ROOM (right side, lower-middle) -->
    <g class="fp-room" data-room="living">
      <rect class="fp-hit" x="380" y="470" width="360" height="200" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="380" y="470" width="360" height="200" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- L-shape sofa arrangement -->
        <!-- Main sofa -->
        <rect x="600" y="500" width="100" height="45" rx="4"/>
        <rect x="600" y="500" width="20" height="45" rx="3"/>
        <rect x="680" y="500" width="20" height="45" rx="3"/>
        <line x1="620" y1="512" x2="680" y2="512"/>
        <line x1="650" y1="512" x2="650" y2="540"/>
        <!-- Second sofa perpendicular -->
        <rect x="600" y="580" width="100" height="45" rx="4"/>
        <rect x="600" y="580" width="20" height="45" rx="3"/>
        <rect x="680" y="580" width="20" height="45" rx="3"/>
        <line x1="620" y1="592" x2="680" y2="592"/>
        <line x1="650" y1="592" x2="650" y2="620"/>
        <!-- Coffee table -->
        <rect x="510" y="540" width="60" height="45" rx="3"/>
        <!-- TV console -->
        <rect x="395" y="500" width="60" height="18" rx="2"/>
        <!-- Armchair -->
        <rect x="395" y="580" width="45" height="45" rx="4"/>
      </g>
      <text x="470" y="500" text-anchor="middle" class="fp-label">Living Room</text>
    </g>

    <!-- MASTER BEDROOM (middle-left) -->
    <g class="fp-room" data-room="master">
      <rect class="fp-hit" x="60" y="290" width="320" height="330" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="60" y="290" width="320" height="330" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- Two twin beds side by side -->
        <rect x="100" y="330" width="70" height="130" rx="4"/>
        <rect x="110" y="340" width="50" height="30" rx="3"/>
        <circle cx="140" cy="355" r="6" fill="#fff"/>

        <rect x="200" y="330" width="70" height="130" rx="4"/>
        <rect x="210" y="340" width="50" height="30" rx="3"/>
        <circle cx="240" cy="355" r="6" fill="#fff"/>

        <!-- Nightstand between them -->
        <rect x="175" y="345" width="20" height="30" rx="2"/>

        <!-- Small sofa/chaise on the right -->
        <rect x="290" y="330" width="60" height="120" rx="4"/>
        <rect x="290" y="330" width="60" height="20" rx="3"/>
        <line x1="290" y1="380" x2="350" y2="380"/>
        <line x1="290" y1="420" x2="350" y2="420"/>

        <!-- Dresser along bottom -->
        <rect x="90" y="530" width="220" height="30" rx="3"/>
        <line x1="145" y1="530" x2="145" y2="560"/>
        <line x1="200" y1="530" x2="200" y2="560"/>
        <line x1="255" y1="530" x2="255" y2="560"/>
      </g>
      <text x="220" y="600" text-anchor="middle" class="fp-label">Master Bedroom</text>
    </g>

    <!-- NURSERY (bottom-left) -->
    <g class="fp-room" data-room="nursery">
      <rect class="fp-hit" x="60" y="620" width="180" height="220" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="60" y="620" width="180" height="220" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- Crib -->
        <rect x="80" y="660" width="65" height="100" rx="4"/>
        <rect x="88" y="675" width="49" height="26" rx="3"/>
        <line x1="80" y1="720" x2="145" y2="720"/>
        <!-- Rocking chair -->
        <rect x="165" y="700" width="60" height="60" rx="4"/>
        <path d="M 165 764 Q 195 780 225 764" fill="none"/>
        <!-- Changing table -->
        <rect x="90" y="785" width="130" height="30" rx="3"/>
      </g>
      <text x="150" y="820" text-anchor="middle" class="fp-label">Nursery</text>
    </g>

    <!-- OFFICE (bottom-middle) -->
    <g class="fp-room" data-room="office">
      <rect class="fp-hit" x="240" y="620" width="200" height="220" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="240" y="620" width="200" height="220" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- Desk -->
        <rect x="270" y="700" width="130" height="40" rx="3"/>
        <line x1="335" y1="700" x2="335" y2="740"/>
        <!-- Monitor -->
        <rect x="295" y="708" width="80" height="24" rx="2"/>
        <!-- Chair -->
        <circle cx="335" cy="770" r="18"/>
        <line x1="317" y1="770" x2="353" y2="770"/>
        <!-- Bookshelf -->
        <rect x="255" y="640" width="170" height="18" rx="2"/>
        <line x1="298" y1="640" x2="298" y2="658"/>
        <line x1="341" y1="640" x2="341" y2="658"/>
        <line x1="384" y1="640" x2="384" y2="658"/>
      </g>
      <text x="340" y="820" text-anchor="middle" class="fp-label">Office</text>
    </g>

    <!-- LAUNDRY ROOM (bottom-right) -->
    <g class="fp-room" data-room="laundry">
      <rect class="fp-hit" x="440" y="620" width="300" height="220" fill="rgba(255,255,255,0.001)"/>
      <rect class="fp-fill" x="440" y="620" width="300" height="220" fill="#ec2a83" opacity="0"/>
      <g class="fp-furniture" stroke="#17181a" stroke-width="1.5" fill="#ffffff" stroke-linejoin="round">
        <!-- Washer -->
        <rect x="470" y="660" width="70" height="85" rx="4"/>
        <circle cx="505" cy="705" r="24"/>
        <circle cx="490" cy="675" r="2" fill="#17181a"/>
        <circle cx="500" cy="675" r="2" fill="#17181a"/>
        <!-- Dryer -->
        <rect x="555" y="660" width="70" height="85" rx="4"/>
        <circle cx="590" cy="705" r="24"/>
        <circle cx="575" cy="675" r="2" fill="#17181a"/>
        <circle cx="585" cy="675" r="2" fill="#17181a"/>
        <!-- Utility sink -->
        <rect x="640" y="660" width="70" height="55" rx="3"/>
        <circle cx="675" cy="687" r="18"/>
        <!-- Laundry basket -->
        <rect x="470" y="770" width="120" height="45" rx="6"/>
        <path d="M 480 780 Q 495 770 510 780 T 540 780 T 570 780" fill="none"/>
      </g>
      <text x="580" y="820" text-anchor="middle" class="fp-label">Laundry Room</text>
    </g>
  </g>
</svg>`;

window.BLC_ROOM_PRODUCTS = {
  bedroom:  ['ap-sage', 'glass-refill', 'floor'],
  bathroom: ['tub-tile-refill', 'toilet', 'glass-refill', 'hand-soap'],
  kitchen:  ['ap-pomegranate', 'dish-soap', 'granite', 'floor'],
  dining:   ['ap-pomegranate', 'ap-sage', 'granite', 'floor'],
  living:   ['ap-pomegranate', 'ap-sage', 'glass-refill', 'floor'],
  master:   ['ap-sage', 'glass-refill', 'floor'],
  nursery:  ['ap-sage', 'glass-refill', 'hand-soap', 'floor'],
  office:   ['ap-sage', 'glass-refill', 'floor'],
  laundry:  ['laundry', 'ap-pomegranate', 'floor']
};

window.BLC_ROOM_META = {
  bedroom:  { name: 'Bedroom',        line: 'Nightstand shine, streak-free mirrors, dust-free vibes.' },
  bathroom: { name: 'Bathroom',       line: 'Tub-to-grout deep clean. Spa vibes, zero fumes.' },
  kitchen:  { name: 'Kitchen',        line: 'Counters that see actual dinner. Grease-cutting, streak-free.' },
  dining:   { name: 'Dining Room',    line: 'Post-dinner counters, chair backs, sticky little fingers.' },
  living:   { name: 'Living Room',    line: 'Coffee-table rings, remote sticky, dusty shelves.' },
  master:   { name: 'Master Bedroom', line: 'Deep-clean the room you retreat to. Gentle, real-scent formulas.' },
  nursery:  { name: 'Nursery',        line: 'Extra-gentle, pet & baby safe. No harsh fumes ever.' },
  office:   { name: 'Office',         line: 'Desk deep-clean, screen streak-free, hands soft.' },
  laundry:  { name: 'Laundry Room',   line: 'Small bottle. Big loads. Plant-based clean.' }
};
